import { CarlineBase, CarlinesWithSalesgroups, OneFormState} from 'src/types';
import { findCarlineFromSalesgroup } from '.';

export const findCarline = (
  carlines: CarlineBase[] | CarlinesWithSalesgroups[],
  code: number,
  salesgroupId?: number
) => {
  const carline = carlines.find((carline: CarlineBase) => carline.code === code);

  if (carline) {
    return carline;
  } else if (salesgroupId) {
    const carline = findCarlineFromSalesgroup(carlines, salesgroupId);
    return carline;
  }
  return null;
};
